import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

/**
 * Centered confirm when leaving a portal form tab with unsaved edits.
 * - Save and next: persist current form, then open the selected tab
 * - Leave anyway: discard and open the selected tab
 * ESC / backdrop dismiss: stay on the current form
 */
const UnsavedChangesModal = ({
  show,
  currentLabel = 'this form',
  nextLabel = 'another form',
  saving = false,
  onSaveAndNext,
  onLeaveAnyway,
  onDismiss,
}) => (
  <Modal
    show={show}
    onHide={saving ? undefined : onDismiss}
    centered
    backdrop={saving ? 'static' : true}
    keyboard={!saving}
    className="user-form-leave-modal-root"
    backdropClassName="user-form-leave-backdrop"
    dialogClassName="user-form-leave-dialog"
    contentClassName="user-form-leave-modal"
    aria-labelledby="user-form-leave-title"
    aria-describedby="user-form-leave-desc"
  >
    <Modal.Body className="user-form-leave-modal__body">
      <div className="user-form-leave-modal__icon" aria-hidden="true">
        <FontAwesomeIcon icon={faExclamationTriangle} />
      </div>
      <h2 id="user-form-leave-title" className="user-form-leave-modal__title">
        Unsaved changes
      </h2>
      <p id="user-form-leave-desc" className="user-form-leave-modal__message">
        You have unsaved changes on <strong>{currentLabel}</strong>. Save them
        before opening <strong>{nextLabel}</strong>, or leave without saving.
      </p>
    </Modal.Body>
    <Modal.Footer className="user-form-leave-modal__footer">
      <button
        type="button"
        className="user-form-leave-modal__btn user-form-leave-modal__btn--leave"
        disabled={saving}
        onClick={onLeaveAnyway}
      >
        Leave anyway
      </button>
      <button
        type="button"
        className="user-form-leave-modal__btn user-form-leave-modal__btn--stay"
        autoFocus
        disabled={saving}
        onClick={onSaveAndNext}
      >
        {saving ? (
          <>
            <Spinner animation="border" size="sm" className="me-2" aria-hidden="true" />
            Saving…
          </>
        ) : (
          'Save and next'
        )}
      </button>
    </Modal.Footer>
  </Modal>
);

export default UnsavedChangesModal;
